import Vue from 'vue'
import Router from 'vue-router'
import teste from '@/components/teste/teste'
import email_validar from '@/components/login/email_validar'
import login from '@/components/login/login'
import cadastro_novo_por_convite from '@/components/login/cadastro_por_convite'
import home from '@/components/home/home'
import home_torneio from '@/components/home_torneio/home_torneio'
import turbo from '@/components/turbo/turbo'
import acontecendo from '@/components/acontecendo/acontecendo'
import meu_torneio_disparo from '@/components/meu/meu_torneio_disparo'
import meu_torneio_historico from '@/components/meu/meu_torneio_historico'
import meu_torneio_andamento from '@/components/meu/meu_torneio_andamento'
import meu_torneio_aguardando from '@/components/meu/meu_torneio_aguardando'
import minha_aposta from '@/components/meu/minha_aposta'
import editar_aposta_sem_componente from '@/components/montar_aposta/editar_aposta_sem_componente'
import torneio_detalhes from '@/components/detalhes/detalhes'
import conta_resumo from '@/components/conta/resumo'
import conta_reset_senha from '@/components/conta/reset_senha'
import conta_dados from '@/components/conta/dados'
import conta_extrato_torneio from '@/components/conta/extrato_torneio'
import conta_extrato_transacao from '@/components/conta/extrato_transacao'
import conta_deposito from '@/components/conta/deposito'
import conta_saque from '@/components/conta/saque'
import conta_auto_exclusao from '@/components/conta/auto_exclusao'
import conta_verificada from '@/components/conta/verificada'
import conta_convite_resumo from '@/components/conta/convite_resumo'
import conta_convite_historico from '@/components/conta/convite_historico'
import conta_convite_ganho from '@/components/conta/convite_ganho'
import conta_convite_transferir from '@/components/conta/convite_transferir'
import esqueceu_senha from '@/components/login/esqueceu_senha'
import esqueceu_senha_validar from '@/components/login/esqueceu_senha_validar'
import torneio_auditoria from '@/components/torneio_auditoria/auditoria'
import dama from '@/components/dama/dama'

Vue.use(Router)

const prefix = ''

const router = new Router({
  routes: [

    {
      path: prefix + '/teste',
      name: 'teste',
      component: teste
    },

    {
      path: prefix + '/dama',
      name: 'dama',
      component: dama
    },

    {
      path: '/email/validar/:token',
      name: 'email_validar',
      component: email_validar
    },

    {
      path: '/login',
      name: 'login',
      component: login
    },

    {
      path: '/cadastro',
      name: 'cadastro_novo',
      component: cadastro_novo_por_convite
    },

    {
      path: '/cadastro/:link_convite',
      name: 'cadastro_novo_por_convite',
      component: cadastro_novo_por_convite
    },

    {
      path: '/esqueceu/senha',
      name: 'esqueceu_senha',
      component: esqueceu_senha
    },

    {
      path: '/esqueceu/senha/validar/:token',
      name: 'esqueceu_senha_validar',
      component: esqueceu_senha_validar
    },

    {
      path: '/',
      name: 'home',
      component: home
    },

    {
      path: '/home/torneio/:tipo_id/:tag_id',
      name: 'home_torneio',
      component: home_torneio
    },

    {
      path: '/acontecendo',
      name: 'acontecendo',
      component: acontecendo
    },

    {
      path: '/meu_torneio',
      name: 'meu_torneio',
      component: meu_torneio_disparo
    },

    {
      path: '/meu_torneio/aguardando',
      name: 'meu_torneio_aguardando',
      component: meu_torneio_aguardando
    },

    {
      path: '/meu_torneio/andamento',
      name: 'meu_torneio_andamento',
      component: meu_torneio_andamento
    },

    {
      path: '/meu_torneio/historico',
      name: 'meu_torneio_historico',
      component: meu_torneio_historico
    },

    {
      path: '/turbo/:tag_id',
      name: 'turbo',
      component: turbo
    },

    {
      path: '/torneio/:torneio_id',
      name: 'minha_aposta_ws_redis',
      component: minha_aposta,
      meta: { autenticacao: true }
    },

    {
      path: '/torneio/:torneio_id/auditoria',
      name: 'torneio_auditoria',
      component: torneio_auditoria,
      meta: { autenticacao: true }
    },

    {
      path: '/palpite/:aposta_id/editar',
      name: 'editar_aposta_sem_componente',
      component: editar_aposta_sem_componente,
      meta: { autenticacao: true }
    },

    {
      path: '/detalhes/torneio/:torneio_id/:page_back',
      name: 'torneio_detalhes',
      component: torneio_detalhes,
      meta: { autenticacao: true }
    },

    { path: '/conta/resumo', name: 'conta_resumo', component: conta_resumo },
    { path: '/conta/reset/senha', name: 'conta_reset_senha', component: conta_reset_senha },
    { path: '/conta/dados', name: 'conta_dados', component: conta_dados },
    { path: '/conta/extrato/torneio', name: 'conta_extrato_torneio', component: conta_extrato_torneio },
    { path: '/conta/extrato/transacao', name: 'conta_extrato_transacao', component: conta_extrato_transacao },
    { path: '/conta/auto_exclusao', name: 'conta_auto_exclusao', component: conta_auto_exclusao },
    { path: '/conta/deposito', name: 'conta_deposito', component: conta_deposito },
    { path: '/conta/saque', name: 'conta_saque', component: conta_saque },
    { path: '/conta/verificada', name: 'conta_verificada', component: conta_verificada },
    { path: '/conta/convite/resumo', name: 'conta_convite_resumo', component: conta_convite_resumo },
    { path: '/conta/convite/historico', name: 'conta_convite_historico', component: conta_convite_historico },
    { path: '/conta/convite/ganho', name: 'conta_convite_ganho', component: conta_convite_ganho },
    { path: '/conta/convite/transferir', name: 'conta_convite_transferir', component: conta_convite_transferir },
    // { path: '/conta/convite/convidado', name: 'conta_convite_convidado', component: conta_convite_convidado },
    // { path: '/conta/convite/ganho', name: 'conta_convite_ganho', component: conta_convite_ganho },

  ],

  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },

})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js